export enum ConnectionSide {
  Left = 'left',
  Right = 'right'
}
